export const whiteLabelData = [
  {
    client_id: "amd",
    name: "AMD Enterprise AI",
    domain: "amd.piosphere.ai",
    logo_url: "https://cdn.yourapp.com/amd/logo.png",
    favicon_url: "https://cdn.yourapp.com/amd/favicon.ico",
    theme: {
      primary_color: "#E91D2D",
      secondary_color: "#30A0E0",
      background_color: "#0D1117",
      text_color: "#FFFFFF",
      accent_color: "#61DAFB"
    },
    font: {
      family: "Inter, 'Segoe UI', Roboto, sans-serif"
    },
    title: "AMD Enterprise AI Platform",
    description: "Advanced AI solutions powered by AMD technology",
    powered_by: "Powered by PioSphere"
  },
  {
    client_id: "baionity",
    name: "Baionity",
    domain: "baionity.piosphere.ai",
    logo_url: "/WhiteLabelLogos/BAIONITY_Favicon.png",
    favicon_url: "/WhiteLabelLogos/BAIONITY_Favicon.png",
    theme: {
      primary_color: "#4CAF50",
      secondary_color: "#FFFFFF",
      background_color: "#000000",
      text_color: "#34D399",
      accent_color: "#34D399"
    },
    font: {
      family: "Poppins, 'SF Pro Display', Roboto, sans-serif"
    },
    title: "Baionity Enterprise AI Platform",
    description: "AI solutions for enterprise digital transformation",
    powered_by: "Powered by PioSphere"
  },
  {
    client_id: "boston-it",
    name: "Boston IT Solutions",
    domain: "boston-it.piosphere.ai",
    logo_url: "https://cdn.yourapp.com/boston-it/logo.png",
    favicon_url: "https://cdn.yourapp.com/boston-it/favicon.ico",
    theme: {
      primary_color: "#0E66C2",
      secondary_color: "#FFB400",
      background_color: "#111827",
      text_color: "#F9FAFB",
      accent_color: "#F43F5E"
    },
    font: {
      family: "Montserrat, 'Helvetica Neue', Arial, sans-serif"
    },
    title: "Boston IT Enterprise AI Platform",
    description: "Enterprise-grade AI solutions for modern businesses",
    powered_by: "Powered by PioSphere"
  },
  {
    client_id: "cloudiogram",
    name: "Cloudiogram",
    domain: "cloudiogram.piosphere.ai",
    logo_url: "/WhiteLabelLogos/cloudiogram.png",
    favicon_url: "/WhiteLabelLogos/cloudiogram.png",
    theme: {
      primary_color: "#333333",
      secondary_color: "#666666",
      background_color: "#FFFFFF",
      text_color: "#000000",
      accent_color: "#4A4A4A"
    },
    font: {
      family: "Inter, 'Segoe UI', Roboto, sans-serif"
    },
    title: "Cloudiogram Enterprise AI Platform",
    description: "Cloud-native AI solutions for modern enterprises",
    powered_by: "Powered by PioSphere"
  },
  {
    client_id: "nexgen",
    name: "NexGen Technologies",
    domain: "nexgen.piosphere.ai",
    logo_url: "https://cdn.yourapp.com/nexgen/logo.png",
    favicon_url: "https://cdn.yourapp.com/nexgen/favicon.ico",
    theme: {
      primary_color: "#6D28D9",
      secondary_color: "#A78BFA",
      background_color: "#0B0F19",
      text_color: "#FFFFFF",
      accent_color: "#14B8A6"
    },
    font: {
      family: "Manrope, system-ui, sans-serif"
    },
    title: "NexGen AI Platform",
    description: "Next generation AI solutions for enterprise",
    powered_by: "Powered by PioSphere"
  },
  {
    client_id: "quantum",
    name: "Quantum Systems",
    domain: "quantum.piosphere.ai",
    logo_url: "https://cdn.yourapp.com/quantum/logo.png",
    favicon_url: "https://cdn.yourapp.com/quantum/favicon.ico",
    theme: {
      primary_color: "#059669",
      secondary_color: "#10B981",
      background_color: "#111111",
      text_color: "#FAFAFA",
      accent_color: "#F59E0B"
    },
    font: {
      family: "Space Grotesk, Roboto, sans-serif"
    },
    title: "Quantum Enterprise AI",
    description: "Advanced AI solutions for modern enterprise",
    powered_by: "Powered by PioSphere"
  }
];
